<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-scroll-top">
        <div class="footer-scroll-top__btn" />
      </div>
      <div class="footer-top">
        <div class="footer__share">
          <a href="https://twitter.com/paycompliance" target="_blank">
            <img src="@/assets/icons/i_twitter.svg" alt="twitter" />
          </a>
          <a
            href="https://www.linkedin.com/company/paymentscompliance/"
            target="_blank"
          >
            <img src="@/assets/icons/i_linkedin.svg" alt="linkedin" />
          </a>
          <a
            href="https://www.youtube.com/@vixioregulatoryintelligence"
            target="_blank"
          >
            <img src="@/assets/icons/i_youtube_corpFill.svg" alt="youtube" />
          </a>
        </div>
        <div class="footer__contacts">
          <div>
            <div>
              <p class="strong">United Kingdom</p>
              <p>
                St Clare House, 30 Minories
                <br />
                London, EC3N 1DD
              </p>
              <a href="tel:+44(0)2079219980" class="strong"
                >+44(0)207 921 9980</a
              >
            </div>
            <div>
              <p class="strong">United States Of America</p>
              <p>
                1250 Connecticut Avenue, NW Suite 700<br />
                Washington D.C., 200036
              </p>
              <a href="tel:+12022613567" class="strong">+1 202 261 3567</a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer__links">
        <div class="footer__links-top">
          <a href="https://vixio.com/contact-us/" target="_blank"> Feedback </a>
          <a href="https://vixio.com/contact-us/" target="_blank">
            Contact us
          </a>
        </div>
        <div class="footer__links-bottom">
          <a href="https://www.vixio.com/terms-and-conditions">
            Terms and Conditions
          </a>
          <a href="https://vixio.com/anti-slavery-policy/" target="_blank">
            Anti-Slavery Policy
          </a>
        </div>
      </div>
      <div class="footer-bottom">
        <p class="copy">
          All rights reserved. ©Compliance Online Limited (trading as VIXIO).
          St. Clare House, 30 Minories, London, EC3N 1DD.
        </p>
      </div>
    </div>
    <Base />
    <BulderDialog />
    <FilterSaver />
    <ConfirmDelete />
  </footer>
</template>

<script>
export default {
  name: "Footer",
  components: {
    Base: () => import("../dialog/Base"),
    BulderDialog: () => import("../dialog/BulderDialog"),
    FilterSaver: () => import("../dialog/FilterSaver"),
    ConfirmDelete: () => import("../dialog/ConfirmDelete"),
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.footer {
  background-color: $corporateBlue;
  background-size: 70% 100%;
  color: $white;
  padding: 5.7rem 0 1.7rem;
  position: relative;
  margin-top: 6rem;

  @include below($md) {
    padding: 2.5rem 0;
    background-color: $corporateBlue;
    background-size: 100% 60%;
    background-position: top;
  }

  .container {
    position: relative;

    @include above($md) {
      padding-right: 20rem;
    }
  }

  a {
    color: $white;
    text-decoration: none;
    transition: 0.3s ease-out;
    &:hover {
      opacity: 0.7;
    }
  }
  h3 {
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 700;
    margin-bottom: 1.3rem;
    text-transform: uppercase;
  }
  &-scroll-top {
    height: 0;
    position: relative;

    &__btn {
      position: absolute;
      right: 0;
      bottom: 0;
      margin-bottom: 5.7rem;

      @include below($md) {
        margin-bottom: 2.5rem;
      }

      button {
        vertical-align: top;
      }
    }
  }
  &-top {
    display: flex;
    flex-direction: column;
    margin-bottom: 7rem;
    @include below($lg) {
      flex-direction: column;
      margin-bottom: 3rem;
    }
    @include below($md) {
      margin-bottom: 2.6rem;
    }
  }
  &-bottom {
    display: flex;
    font-size: 1.3rem;
    @include below($md) {
      flex-direction: column;
    }
    p {
      margin-right: 3rem;
      @include below($md) {
        margin-right: 0;
        margin-bottom: 1.2rem;
        color: $white;
      }
    }
    a {
      margin-right: 2rem;
      @include below($md) {
        margin-right: 0;
      }
    }
  }
  &__links {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    position: absolute;
    right: 3.4rem;
    top: 0;

    @include below($md) {
      position: unset;
      margin-bottom: 2rem;
      margin-top: 15rem;
    }

    & > div {
      display: flex;
      flex-direction: column;
    }
    a {
      color: $white;
      text-align: right;
      font-weight: 300;
      @include below($md) {
        text-align: left;
      }
    }
    &-bottom {
      @include below($md) {
        margin-top: 2rem;
      }
      a {
        font-size: 1.3rem;
      }
    }
  }
  &__share {
    a {
      margin-right: 2rem;
    }
  }
  &__contacts {
    margin-top: 2.5rem;

    h3 {
      margin-bottom: 2.3rem;
      @include below($md) {
        margin-bottom: 1rem;
      }

      &.strong {
        font-weight: 600;
      }
    }
    p {
      font-size: 1.4rem;
      &:first-of-type {
        font-weight: 600;
      }
    }
    a {
      font-size: 1.4rem;
      font-weight: 600;
    }
    & > div {
      display: flex;
      @include below($md) {
        flex-direction: column;
      }
      & > div:first-of-type {
        margin-right: 5rem;
        @include below($md) {
          margin-right: 0;
          margin-bottom: 2rem;
        }
      }
    }
  }
}
</style>
